import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Bookings
  createBooking: async (data) => {
    const response = await axios.post(`${API}/bookings`, data);
    return response.data;
  },

  getBookings: async () => {
    const response = await axios.get(`${API}/bookings`);
    return response.data;
  },

  getBooking: async (id) => {
    const response = await axios.get(`${API}/bookings/${id}`);
    return response.data;
  },

  generateWhatsAppTemplate: async (data) => {
    const response = await axios.post(`${API}/bookings/whatsapp-template`, data);
    return response.data;
  },

  // Applications
  createApplication: async (data) => {
    const response = await axios.post(`${API}/applications`, data);
    return response.data;
  },

  getApplications: async () => {
    const response = await axios.get(`${API}/applications`);
    return response.data;
  },

  // File Upload
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Analytics
  trackEvent: async (eventType, eventName, page, metadata = {}) => {
    try {
      await axios.post(`${API}/analytics/event`, {
        event_type: eventType,
        event_name: eventName,
        page: page,
        metadata: metadata
      });
    } catch (error) {
      console.error('Analytics tracking failed:', error);
    }
  },

  getAnalyticsSummary: async () => {
    const response = await axios.get(`${API}/analytics/summary`);
    return response.data;
  },

  // Health check
  healthCheck: async () => {
    const response = await axios.get(`${API}/health`);
    return response.data;
  }
};

export default api;
